import React from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {
    // @default 1
    count?: number;
};

const CardsSkeleton: React.FC<Props> = ({ count = 1 }) => (
    <article className="debit-card-links__wrapper">
        <h3 className="debit-card-links__title">
            <Skeleton height={24} width={120} />
        </h3>
        <ul className="debit-card-links__list">
            {Array.from(Array(count === 0 ? 1 : count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className="debit-card-links__list-item">
                    <Skeleton height={120} />
                </div>
            ))}
        </ul>
    </article>
);

export default CardsSkeleton;
